<div class="bg-white rounded-xl shadow-2xl w-full overflow-hidden">
  <!-- Champ -->
  <div class="flex items-center gap-3 px-4 border-b border-gray-200">
    <fa-icon [icon]="faMagnifyingGlass" class="text-gray-400 text-base shrink-0" aria-hidden="true"></fa-icon>
    <input
      #input
      type="text"
      cdkFocusInitial
      role="combobox"
      aria-label="Rechercher un bail, un propriétaire, un locataire ou un bien"
      aria-controls="command-palette-listbox"
      aria-autocomplete="list"
      [attr.aria-expanded]="hits().length > 0"
      [attr.aria-activedescendant]="activeId()"
      autocomplete="off"
      spellcheck="false"
      placeholder="Rechercher un bail, un propriétaire, un locataire, un bien…"
      [value]="query()"
      (input)="onInput($any($event.target).value)"
      (keydown)="onKeydown($event)"
      class="flex-1 min-w-0 py-4 text-base text-gray-900 placeholder:text-gray-400 bg-transparent border-0 focus:outline-none focus:ring-0"
    />
    @if (loading()) {
      <span class="w-4 h-4 shrink-0 rounded-full border-2 border-gray-200 border-t-[#993225] animate-spin" role="status" aria-label="Recherche en cours"></span>
    }
    <kbd class="hidden sm:inline-block shrink-0 px-1.5 py-0.5 text-[11px] font-medium text-gray-500 bg-gray-100 border border-gray-200 rounded">Échap</kbd>
  </div>

  <!-- Résultats -->
  <div #listbox id="command-palette-listbox" role="listbox" aria-label="Résultats" class="max-h-[60vh] overflow-y-auto">
    @if (tooShort()) {
      <p class="px-4 py-6 text-sm text-gray-500 text-center">
        Tapez au moins {{ minLength }} caractères.
      </p>
    } @else if (error()) {
      <p class="px-4 py-6 text-sm text-red-700 text-center">
        La recherche a échoué. Réessayez dans un instant.
      </p>
    } @else if (answeredQuery() !== null && hits().length === 0 && !loading()) {
      <p class="px-4 py-6 text-sm text-gray-500 text-center">
        Aucun résultat pour « {{ answeredQuery() }} ».
      </p>
    }

    @for (group of groups(); track group.kind) {
      <div role="group" [attr.aria-label]="group.title" class="py-1.5">
        <div class="px-4 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
          {{ group.title }}
        </div>
        @for (row of group.rows; track row.hit.kind + row.hit.id) {
          <div class="group relative mx-2" (mousemove)="row.index !== activeIndex() && setActive(row.index)">
            <a
              [id]="optionId(row.index)"
              role="option"
              [attr.aria-selected]="row.index === activeIndex()"
              [routerLink]="link(row.hit)"
              (click)="onRowClick($event)"
              tabindex="-1"
              class="flex items-center gap-3 pl-2 pr-11 py-2 rounded-lg cursor-pointer transition-colors duration-100"
              [class.bg-primary-50]="row.index === activeIndex()"
            >
              <span
                class="w-8 h-8 shrink-0 rounded-lg flex items-center justify-center"
                [class.bg-gray-100]="row.index !== activeIndex()"
                [class.text-gray-500]="row.index !== activeIndex()"
                [class.bg-white]="row.index === activeIndex()"
                [class.text-primary-800]="row.index === activeIndex()"
              >
                <fa-icon [icon]="group.icon" aria-hidden="true"></fa-icon>
              </span>
              <span class="flex flex-col min-w-0 flex-1">
                <span class="text-sm font-medium text-gray-900 truncate">{{ row.hit.label }}</span>
                @if (row.hit.sublabel) {
                  <span class="text-xs text-gray-500 truncate">{{ row.hit.sublabel }}</span>
                }
              </span>
              @if (row.hit.ended) {
                <span class="shrink-0 px-1.5 py-0.5 text-[11px] font-medium text-gray-500 bg-gray-100 rounded">Terminé</span>
              }
            </a>
            <!-- Frère du lien et non enfant : un bouton dans un <a> n'est pas du HTML valide.
                 Visible sur la ligne active (clavier) comme au survol (souris). -->
            <button
              type="button"
              (click)="showGraph(row.hit, $event)"
              [title]="'Voir dans le graphe du propriétaire (' + (isMac ? '⌘' : 'Ctrl+') + '⇧K)'"
              aria-label="Voir dans le graphe du propriétaire"
              tabindex="-1"
              class="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 rounded-md flex items-center justify-center text-gray-400 transition-opacity duration-150 hover:bg-white hover:text-primary-800 cursor-pointer group-hover:opacity-100"
              [class.opacity-0]="row.index !== activeIndex()"
              [class.opacity-100]="row.index === activeIndex()"
            >
              <fa-icon [icon]="faDiagramProject" class="text-[14px] leading-none" aria-hidden="true"></fa-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>

  <!-- Aide clavier -->
  <div class="flex items-center gap-4 px-4 py-2 border-t border-gray-100 bg-gray-50 text-[11px] text-gray-500">
    <span><kbd class="font-sans">↑</kbd> <kbd class="font-sans">↓</kbd> naviguer</span>
    <span><kbd class="font-sans">Entrée</kbd> ouvrir</span>
    <span><kbd class="font-sans">{{ isMac ? '⌘' : 'Ctrl' }}+Entrée</kbd> nouvel onglet</span>
    <span class="ml-auto"></span>
    <app-palette-switcher active="search" [graphHint]="graphHint()" (switchTo)="onSwitch($event)" />
  </div>
</div>
